import { render, staticRenderFns } from "./PFEmployeeLoanApplicationApproveList.vue?vue&type=template&id=ebf87a06"
import script from "./PFEmployeeLoanApplicationApproveList.vue?vue&type=script&lang=js"
export * from "./PFEmployeeLoanApplicationApproveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports